(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-custom-tabs"] && !Shopify.designMode) return;
  try {
    
  const tabs = document.querySelectorAll('.custom-tab');
  const tabContents = document.querySelectorAll('.custom__tab-content');
  
  // Enhanced tab functionality with smoother transitions
  tabs.forEach(function(tab, index) {
    tab.addEventListener('click', function() {
      switchTab(this);
    });
    
    // Keyboard accessibility
    tab.addEventListener('keydown', function(e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        switchTab(this);
      }
    });
  });
  
  function switchTab(activeTab) {
    const contentId = activeTab.dataset.contentId;
    const content = document.getElementById(contentId);
    
    // Remove active states
    tabContents.forEach(function(content) {
      content.classList.remove('active');
      content.setAttribute('aria-hidden', 'true');
    });
    
    tabs.forEach(function(tab) {
      tab.classList.remove('active');
      tab.setAttribute('aria-selected', 'false');
    });
    
    // Add loading state briefly for smooth transition
    content.classList.add('loading');
    
    // Set active states with slight delay for smooth animation
    setTimeout(() => {
      activeTab.classList.add('active');
      activeTab.setAttribute('aria-selected', 'true');
      content.classList.add('active');
      content.setAttribute('aria-hidden', 'false');
      content.classList.remove('loading');
    }, 50);
  }
  
  // Auto-focus management for better UX
  document.addEventListener('DOMContentLoaded', function() {
    const firstTab = document.querySelector('.custom-tab');
    if (firstTab) {
      firstTab.focus();
    }
  });

  } catch(e) { console.error(e); }
})();
})();
